<!-- ---------------------------------- NEW ITINERARY -------------------------- -->

<div class="section-topextend" *ngIf="!reload && !chargeClient">
  <a class="loader text-center justify-content-center align-items-center" style="padding-top: 0.5em">
    <i class="fa fa-spinner fa-spin"></i><span class="ml-2">Cargando, espere por favor...</span>
  </a>
</div>

<ng-container *ngIf="reload">
  <div class="section-topextend" *ngIf="!saved && loaded">
    <div class="d-flex justify-content-between container-fluid align-items-center">
      <!-- <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent"> -->
      <div>
        <form [formGroup]="_formGroupItinerary" style="height: 45px" class="d-flex align-items-center">
          <span class="d-flex align-items-center justify-content-center" style="gap: 0.3em">
            <!-- <svg-icon src="../../../assets/img/app/top-extend/world-wide-web.svg" style="margin-right: 10px;"
            [ngStyle]="{'fill': sectionHeader?.icon_color}"></svg-icon> -->
            <i class="bi bi-globe" style="font-size: 1.5em" [ngStyle]="{ color: sectionHeader?.icon_color }"></i>
            <input
              #itineraryName
              class="form-control menu-sesion input-header me-2"
              style="width: 230px"
              type="text"
              placeholder="Nombre File"
              name="title"
              aria-label="Title"
              formControlName="title"
              maxlength="50"
              autocomplete="off"
            />
          </span>
          <span id="autocomplete-container" class="d-flex align-items-center justify-content-center" style="margin-left: 15px; gap: 0.3em">
            <!-- <svg-icon src="../../../assets/img/app/top-extend/user.svg" style=" margin-right: 7px;"
            [ngStyle]="{'fill': sectionHeader?.icon_color}"></svg-icon> -->
            <i
              class="bi bi-person-fill"
              style="font-size: 1.5em; -webkit-text-stroke: 1.2px"
              [ngStyle]="{ color: sectionHeader?.icon_color }"
            ></i>
            <input
              #name
              class="form-control menu-sesion input-header me-2"
              style="width: 180px"
              type="text"
              placeholder="Nombre cliente"
              name="client"
              formControlName="name"
              maxlength="50"
              autocomplete="off"
              aria-label="Name"
            />
          </span>
          <span class="d-flex px-0 align-items-center justify-content-start" style="margin-left: 15px; gap: 0.3em">
            <!-- <svg-icon src="../../../assets/img/app/top-extend/mail.svg" style="fill: black; margin-left: 15px;"
            [ngStyle]="{'fill': sectionHeader?.icon_color}"></svg-icon> -->
            <i class="bi bi-envelope-fill" style="font-size: 1.5em" [ngStyle]="{ color: sectionHeader?.icon_color }"></i>
            <input
              #email
              class="form-control menu-sesion input-header me-2"
              style="width: 175px"
              type="text"
              maxlength="50"
              placeholder="E-mail"
              name="email"
              (ngModelChange)="resetSaveFormFields(clientLoaded)"
              formControlName="email"
              autocomplete="off"
              aria-label="Mail"
            />
            <button
              type="submit"
              class="btn btn-sm btn-search"
              style="margin-left: -5px"
              data-placement="bottom"
              (click)="openModalExtraLarge()"
            >
              <i class="fa fa-search"></i>
            </button>
          </span>
          <span class="d-flex align-items-center justify-content-start" style="margin-left: 15px; gap: 0.3em">
            <i class="bi bi-telephone-fill" style="font-size: 1.5em" [ngStyle]="{ color: sectionHeader?.icon_color }"></i>

            <ng-container *ngIf="_formGroupItinerary.get('phone_code').value === null">
              <input
                id="phone_code"
                name="phone_code"
                matInput
                class="form-control menu-sesion input-header me-2 no-spinner"
                style="
                  font-family: 'Poppins', sans-serif !important;
                  font-size: 13px;
                  font-weight: 500 !important;
                  padding-left: 15px;
                  padding-top: 5px;
                  width: 180px;
                  margin-top: 1px;
                  height: 26px !important;
                  color: #464646;
                "
                aria-label="phone_code"
                [matAutocomplete]="auto"
                (input)="filterCountries($event.target.value)"
                (focus)="getCountries()"
                (keydown)="blockInvalidKeys($event, 'name')"
                autocomplete="off"
                placeholder="País + Cod. telefónico"
              />
              <mat-autocomplete
                id="matCountry"
                #matCountry
                #auto="matAutocomplete"
                (optionSelected)="updateMySelectionNationality($event.option.value)"
                [displayWith]="displayCountry"
              >
                <mat-option *ngFor="let country of filteredCountries" [value]="country.phone_code">
                  {{ country.country_name }}
                </mat-option>
              </mat-autocomplete>
            </ng-container>

            <span *ngIf="_formGroupItinerary.get('phone_code').value !== null" style="position: relative">
              <span class="container-input-icon-cancel">
                <input
                  id="phone_code"
                  name="phone_code"
                  matInput
                  class="form-control menu-sesion input-header me-2 no-spinner"
                  style="
                    font-family: 'Poppins', sans-serif !important;
                    font-size: 13px;
                    font-weight: 500 !important;
                    padding-left: 15px;
                    padding-top: 5px;
                    width: 180px;
                    margin-top: 1px;
                    height: 26px !important;
                    color: #464646;
                    background-color: white;
                  "
                  aria-label="phone_code"
                  autocomplete="off"
                  value="{{ phoneCodeSelected }}"
                  readonly
                />
                <span class="square-class-secondArrival">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar código telefónico"
                      placement="bottom"
                      (click)="resetPhoneCode()"
                    ></i>
                  </div>
                </span>
              </span>
              <!-- <span  class="square-class-secondArrival">
                <div class="container-square-secondArrival">
                  <i class="bi bi-square square-icon"
                  [ngStyle]="{
                    'text-shadow': isHoveredCancelDate ? '0px 0px 5px red' : ''
                      }"
                      (mouseenter)="isHoveredCancelDate = true" (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar código telefónico"
                      placement="bottom"
                      (click)="resetPhoneCode()"
                      ></i>
                  <i class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true" (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar código telefónico"
                      placement="bottom"
                      (click)="resetPhoneCode()"
                      ></i>
                </div>
              </span> -->
            </span>

            <input
              #phone
              class="form-control menu-sesion input-header me-2 no-spinner"
              style="width: 125px"
              type="number"
              (keydown)="blockInvalidKeys($event, 'number')"
              placeholder="N° Teléfono"
              name="phone"
              formControlName="phone"
              autocomplete="off"
              aria-label="Phone"
            />
          </span>
          <button
            type="submit"
            class="btn btn-sm btn-save-client"
            data-placement="bottom"
            style="height: 26px; width: 125px; margin-left: 16px; text-align: start; padding: 5px 18px; line-height: 1"
            (click)="saveFirstItinerary()"
            [disabled]="!_formGroupItinerary.valid"
            *ngIf="this.clientLoaded"
            [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          >
            GUARDAR
          </button>
          <button
            type="submit"
            class="btn btn-sm btn-save-client"
            data-placement="bottom"
            style="height: 26px; width: 125px; margin-left: 16px; text-align: start; padding: 5px 18px; line-height: 1"
            (click)="verifyExist()"
            [disabled]="!isGuardarButtonEnabled()"
            *ngIf="!this.clientLoaded"
            [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          >
            GUARDAR
          </button>
          <div *ngIf="currencyAgency" class="d-flex ml-2">
                  <span
                    class="menu-sesion input-header"
                    style="display: flex; align-items: center; width: auto"
                    [ngStyle]="{ color: sectionHeader?.icon_color }"
                    >Moneda:&nbsp;</span
                  >
                  <span  class="menu-sesion input-header"
                  style="display: flex; align-items: center; width: auto"
                   [ngStyle]="{ color: sectionHeader?.icon_color }">{{ currencyAgency?.code }}</span>
                  <div *ngIf="currencyAgency && currencies && currencies.length > 0" class="info-tool d-flex flex-column position-relative">
                      <!-- <i class="fa fa-exclamation-circle"
                   aria-hidden="true"
                   style="font-size: 13px;"
                   [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i> -->
                   <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                    <span class="tooltip-info shadow-md">
                      <table>
                        <tr>
                          <th style="text-align: center">
                            <p>USD</p>
                          </th>
                          <th style="text-align: center">
                            <p>{{currencyAgency?.code}}</p>
                          </th>
                          <th style="text-align: center">
                            <p>Ultima actualización</p>
                          </th>
                        </tr>
                        <!-- <ng-container *ngFor="let currency of currencies"> -->
                          <tr>
                            <td>
                              <p>USD 1.00</p>
                            </td>
                            <td>
                               <p>{{currencyAgency?.code}} {{currencyAgency?.rate | number: '1.2-2'}}</p>
                            </td>
                            <td>
                               <p>{{currencyAgency?.updated_at | date: 'dd/MM/yyyy, h:mm a'}}</p>
                            </td>
                          </tr>
                        <!-- </ng-container> -->
                      </table>
                    </span>
                  </div>
                </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<!-- ---------------------------------- ERROR FORM -------------------------- -->

<div class="error error-container">
  <div>
    <span *ngIf="_formGroupItinerary.get('title').touched && _formGroupItinerary.get('title').hasError('required')">
      El campo "Nombre del file" es obligatorio.
    </span>

    <span *ngIf="_formGroupItinerary.get('title').touched && _formGroupItinerary.get('title').hasError('spaceOnlyBlank')">
      El campo no acepta sólo espacios en blanco.
    </span>
  </div>

  <div>
    <span
      *ngIf="
        !_formGroupItinerary.get('name').hasError('required') &&
        _formGroupItinerary.get('name').touched &&
        _formGroupItinerary.get('name').hasError('invalidname')
      "
    >
      Por favor ingrese un nombre completo válido. Ejemplo: 'Primero Último'.
    </span>

    <span
      *ngIf="
        !_formGroupItinerary.get('email').hasError('required') &&
        _formGroupItinerary.get('email').touched &&
        _formGroupItinerary.get('email').hasError('invalidemail')
      "
    >
      Por favor ingrese un formato de correo electrónico válido. Ejemplo: 'mi.usuario@dominio.com'.
    </span>
  </div>

  <div>
    <span
      *ngIf="
        (!_formGroupItinerary.get('email').hasError('required') &&
          _formGroupItinerary.get('email').touched &&
          _formGroupItinerary.get('email').hasError('emailTaken')) ||
        clientEmailTake
      "
    >
      Este correo electronico ya esta en uso.
    </span>
  </div>

  <div>
    <span
      *ngIf="
        !_formGroupItinerary.get('phone').hasError('required') &&
        _formGroupItinerary.get('phone').touched &&
        _formGroupItinerary.get('phone').hasError('pattern') &&
        !isPhoneValidating
      "
    >
      Ingrese su número incluyendo el código de área (sin 0 inicial). El número debe tener al menos 6 caracteres.
    </span>
  </div>

  <div>
    <span
      style="color: #3498db !important"
      *ngIf="!_formGroupItinerary.get('phone').hasError('required') && _formGroupItinerary.get('phone').touched && isPhoneValidating"
    >
      Verificando número...
    </span>
  </div>

  <div>
    <span *ngIf="_formGroupItinerary.get('phone')?.hasError('invalidPhone') && _formGroupItinerary.get('phone')?.touched">
      El número ingresado no es válido.
    </span>
  </div>
</div>

<!-- ---------------------------------- iTINERARY CLIENT -------------------------- TODO ACA-->

<div class="section-topextend" *ngIf="!loaded && chargeClient">
  <a class="loader text-center justify-content-center align-items-center" style="padding-top: 0.5em">
    <i class="fa fa-spinner fa-spin"></i><span class="ml-2">Cargando cliente, espere por favor...</span>
  </a>
</div>


<ng-container *ngIf="reload">
  <nav id="new-itinerary" class="section-topextend mx-0 mt-0" *ngIf="saved && loaded">
    <div class="d-flex justify-content-between container-fluid align-items-center">
      <form [formGroup]="_formGroupItinerary" style="height: 45px; width: 100%" class="d-flex align-items-center">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex justify-content-start">
            <div class="d-flex flex-row align-items-center w-50">
              <!-- <svg-icon src="../../../assets/img/app/top-extend/smartphone.svg" [ngStyle]="{'fill': sectionHeader?.icon_color}" style="margin-right: 7px;"></svg-icon> -->
              <span class="d-flex align-items-center text-ellipsis menu-sesion input-header" [ngStyle]="{ color: sectionHeader?.icon_color }" style="width: 70px;">FILE N°</span>
              <span
                class="menu-sesion input-header text-ellipsis ml-2"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
                style="opacity: 0.75; display: flex; align-items: center; font-size: 15px;"
                >{{
                    userService.itineraryActive &&
                    userService.itineraryActive.length > 0 ?
                    userService.itineraryActive[0].id :
                    ''
                  }}</span
              > <!-- Bug fixeado 18/1/2026 - id undefined frente a la carga -->
            </div>
            <div class="d-flex align-items-center" style="margin-right: 25px">
              <!-- <svg-icon src="../../../assets/img/app/top-extend/world-wide-web.svg"  [ngStyle]="{'fill': sectionHeader?.icon_color}" style="margin-right: 10px;"></svg-icon> -->
              <i class="bi bi-globe" style="font-size: 1.5em" [ngStyle]="{ color: sectionHeader?.icon_color }"></i>
              <span
                class="menu-sesion input-header text-ellipsis ml-2"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
                style="opacity: 0.75; display: flex; align-items: center"
                >{{ title.value }}</span
              >
            </div>
            <div class="d-flex align-items-center" style="margin-right: 25px">
              <!-- <svg-icon src="../../../assets/img/app/top-extend/user.svg" [ngStyle]="{'fill': sectionHeader?.icon_color}" style="margin-right: 7px;"></svg-icon> -->
              <i
                class="bi bi-person-fill"
                style="font-size: 1.5em; -webkit-text-stroke: 1.2px"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
              ></i>
              <span
                class="menu-sesion input-header text-ellipsis ml-2"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
                style="opacity: 0.75; display: flex; align-items: center"
                >{{ name.value }}</span
              >
            </div>
            <div class="d-flex align-items-center" style="margin-right: 25px">
              <!-- <svg-icon src="../../../assets/img/app/top-extend/mail.svg" [ngStyle]="{'fill': sectionHeader?.icon_color}" style="margin-right: 10px;"></svg-icon> -->
              <i class="bi bi-envelope-fill" style="font-size: 1.5em" [ngStyle]="{ color: sectionHeader?.icon_color }"></i>
              <span
                class="menu-sesion input-header text-ellipsis ml-2"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
                style="opacity: 0.75; display: flex; align-items: center; width:auto"
                >{{ email.value }}</span
              >
            </div>
            <div class="d-flex align-items-center" style="margin-right: 25px">
              <!-- <svg-icon src="../../../assets/img/app/top-extend/smartphone.svg" [ngStyle]="{'fill': sectionHeader?.icon_color}" style="margin-right: 7px;"></svg-icon> -->
              <i class="bi bi-telephone-fill" style="font-size: 1.5em" [ngStyle]="{ color: sectionHeader?.icon_color }"></i>
              <span
                class="menu-sesion input-header text-ellipsis ml-2"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
                style="opacity: 0.75; display: flex; align-items: center"
                >{{ phoneCodeClient(phone_code.value) }} {{ phone.value }}</span
              >
            </div>

          </div>

          <!-- Dates and buttons -->
          <div
            class="d-flex align-items-center justify-content-end"
            style="max-width: 604px; min-width: 420px"
            *ngIf="userService.itineraryActive.length > 0"
          >
            <div class="d-flex" style="margin-right: 12px" *ngIf="userService?.itineraryActive[0]?.items && userService.itineraryActive[0]?.items?.length > 0">
              <div class="d-flex justify-content-end cursor-pointer mr-2">
                <span class="date-in-out" [ngStyle]="{ color: sectionHeader?.icon_color }" *ngIf="userService.itineraryArrivalDate && userService.itineraryDepartureDate">
                  In {{getDateInOut(userService.itineraryArrivalDate) }} / Out
                  {{getDateInOut(userService.itineraryDepartureDate) }}
                </span>
              </div>
            </div>
<!--
            <div *ngIf="userService?.itineraryActive?.length > 0">
              <span
                *ngIf="userService.itineraryActive[0]?.currency"
                class="menu-sesion input-header"
                style="display: flex; align-items: center; width: auto"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
                >Moneda: {{ userService.itineraryActive[0]?.currency }}</span
              >
            </div> -->


            <div *ngIf="currencyAgency" class="d-flex">
              <span
                class="menu-sesion input-header"
                style="display: flex; align-items: center; width: auto"
                [ngStyle]="{ color: sectionHeader?.icon_color }"
                >Moneda: {{ currencyAgency?.code }}</span
              >
              <div *ngIf="currencyAgency && currencies && currencies.length > 0" class="info-tool d-flex flex-column position-relative">
                  <!-- <i class="fa fa-exclamation-circle"
                   aria-hidden="true"
                   style="font-size: 13px;"
                   [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i> -->
                   <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                <span class="tooltip-info shadow-md">
                  <table>
                    <tr>
                      <th style="text-align: center">
                        <p>USD</p>
                      </th>
                      <th style="text-align: center">
                        <p>{{currencyAgency?.code}}</p>
                      </th>
                      <th style="text-align: center">
                        <p>Ultima actualización</p>
                      </th>
                    </tr>
                    <!-- <ng-container *ngFor="let currency of currencies"> -->
                      <tr>
                        <td>
                          <p>USD 1.00</p>
                        </td>
                        <td>
                           <p>{{currencyAgency?.code}} {{currencyAgency?.rate | number: '1.2-2'}}</p>
                        </td>
                        <td>
                           <p>{{currencyAgency?.updated_at | date: 'dd/MM/yyyy, h:mm a'}}</p>
                        </td>
                      </tr>
                    <!-- </ng-container> -->
                  </table>
                </span>
              </div>
            </div>

            <!-- <div class="d-flex" style="margin-right: 12px;" *ngIf="userService.itineraryActive[0].items.length == 0">
            <div class="justify-content-end cursor-pointer mr-2">
              <span class="font-poppins date-in-out">
                Check In: -
              </span>
            </div>
            <div class="justify-content-end cursor-pointer mr-2">
              <span class="font-poppins date-in-out">
                / Check Out: -
              </span>
            </div>
          </div> -->

            <div class="d-flex">
              <div class="text-end" style="margin-left: 15px">
                <button
                  type="button"
                  class="badge rounded-pill text-white btn-new-itinerary"
                  [ngStyle]="{'border': '2px solid ' + sectionHeader?.icon_color }"
                  style="height: 28px; width: 125px"
                  data-placement="bottom"
                  title="Go Itinerary"
                  (click)="active()"
                >
                  <div class="d-flex px-1" style="height: 16.5px; justify-content: space-between; align-items: center; width: 117px">
                    <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 600;"
                    [ngStyle]="{ 'color':sectionHeader?.icon_color  }">Ver File</p>
                    <!-- <div style="position: relative; margin-right: 1px">
                      <i style="font-size: 20px;" [ngStyle]="{'color': sectionHeader?.icon_color }" class="bi bi-check-circle-fill"></i>
                    </div> -->
                  </div>
                </button>
              </div>
              <!-- *ngIf="href == '/home' " -->
              <div class="text-end" style="margin-left: 15px">
                <button
                  id="newItinerary"
                  type="button"
                  class="badge rounded-pill text-white btn-new-itinerary"
                  style="height: 28px; width: 125px"
                  [ngStyle]="{'border': '2px solid ' + sectionHeader?.icon_color }"
                  data-placement="bottom"
                  title="Nuevo file"
                  (click)="openNewItinerary()"
                >
                  <div class="d-flex px-1" style="height: 16.5px; justify-content: space-between; align-items: center; width: 117px">
                    <p
                      class="mb-0"
                      style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 600"
                      [ngStyle]="{ color: sectionHeader?.icon_color }"
                    >
                      Nuevo File
                    </p>
                    <div style="position: relative; margin-right: 1px">
                      <i class="bi bi-plus-circle-fill" style="font-size: 20px" [ngStyle]="{ color: sectionHeader?.icon_color }"></i>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </nav>
</ng-container>
<!-------------------------- CREACIÓN DE CLIENTES -------------------------------->

<div *ngIf="clientExists" class="col-10 client-exists client-exists-container">
  <span class="d-flex align-center justify-content-center" style="height: 30px; align-items: center">
    <div class="error-outline"></div>
    <span>Cliente ya existente. Verifique que los datos sean adecuados</span>
  </span>
</div>

<div *ngIf="clientCreated" class="col-10 client-add client-add-container">
  <span class="d-flex align-center justify-content-center" style="height: 30px; align-items: center">
    <!-- mat-icon -->
    <!-- style="font-size: 28px; color: black;margin-bottom: 6px; margin-right: .5em; font-weight: 500 " -->
    <!-- check_circle_outline -->
    <div class="check-outline"></div>
    <span>Cliente creado satisfactoriamente </span>
  </span>
</div>

<div *ngIf="clientConectError" class="col-10 client-error-conect client-error-conect-container">
  <span class="d-flex align-center justify-content-center" style="height: 30px; align-items: center">
    <mat-icon rel="preload" style="font-size: 28px; color: white; margin-bottom: 6px; margin-right: 0.5em; font-weight: 500"
      >highlight_off</mat-icon
    >
    <span>Error al crear el cliente. Intente nuevamente más tarde</span>
  </span>
</div>

<!-- ---------------------------------- MODAL CLIENT INFORMATION -------------------------- -->

<!-- MODAL CLIENT INFORMATION - REPLACED BY ClientListModalComponent -->
<!-- El modal inline #templatePrueba fue reemplazado por usb-client-list-modal -->
<!-- que se renderiza via BsModalService.show(ClientListModalComponent) -->

<!-- ---------------------------------- OLD NEW ITINERARY -------------------------- -->

<!-- <div class="section-topextend" *ngIf="(!saved && loaded)">
  <form [formGroup]="_formGroupItinerary" style="height:45px" class="d-flex align-items-center">
    <div class="d-flex align-content-center justify-content-start col-sm-12 m-0 p-0" style="height: 45px;">
      <div class="nav pl-3 justify-content-start flex-xs-row col-xg-12 col-lg-12 col-md-12 col-sm-12 text-left" style="height: 45px;">

        <div class="d-flex align-items-center justify-content-center inputs-owner px-0">

          <i class="icon-world-header mr-2"></i>
          <input class="menu-sesion input-header px-3" placeholder="Name of the itinerary" name="title" formControlName="title"
            maxlength="50" autocomplete="off" />

        </div>

        <div id="autocomplete-container" class="d-flex align-items-center justify-content-center px-0 inputs-owner">
          <i class="icon-user-header mr-2"></i>
          <input class="menu-sesion input-header m-0 px-3" placeholder="Name" name="client" formControlName="name" maxlength="50"
            autocomplete="off" />
        </div>

        <div class="d-flex px-0 align-items-center justify-content-center inputs-owner">
          <i class="icon-mail-header mr-2"></i>
          <input class="menu-sesion input-header px-3 input-header-mail" maxlength="50" placeholder="E-mail" name="email" type="email"
            (ngModelChange)="resetSaveFormFields(clientLoaded)" formControlName="email" autocomplete="off"
            style="border-bottom-right-radius: 0pt;     border-top-right-radius: 0pt;" />
          <button type="submit" class="btn btn-sm btn-search" data-placement="bottom" (click)="openModalExtraLarge(templatePrueba)">
            <i class="fa fa-search"></i>
          </button>
        </div>

        <div class="d-flex px-0 align-items-center justify-content-center inputs-owner">
          <i class="icon-tel-header mr-2"></i>
          <input class="menu-sesion input-header px-3" maxlength="50" placeholder="Phone" name="phone"
            (ngModelChange)="resetSaveFormFields(clientLoaded)" formControlName="phone" autocomplete="off" />
        </div>
        <div class="d-flex pl-2 align-items-center justify-content-end">
          <button type="submit" class="btn btn-sm btn-usblick ml-2" data-placement="bottom" style="height: 32px !important;"
            (click)="saveFirstItinerary();" [disabled]="!_formGroupItinerary.valid" *ngIf="this.clientLoaded" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}">
            Guardar
          </button>
          <button type="submit" class="btn btn-sm btn-usblick ml-2" data-placement="bottom" style="height: 32px !important;"
            (click)="verifyExist();" [disabled]="!_formGroupItinerary.valid" *ngIf="!this.clientLoaded">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </form>
</div> -->
